var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn && _vm.userProfile.memberId
    ? _c(
        "b-container",
        {
          directives: [
            {
              name: "animate-css",
              rawName: "v-animate-css",
              value: "fadeIn",
              expression: "'fadeIn'"
            }
          ],
          staticClass: "profileView",
          attrs: { fluid: "" }
        },
        [
          _c(
            "b-row",
            [
              !_vm.userProfile.profileComplete || !_vm.userProfile.phoneVerified
                ? _c("b-col", { staticClass: "profileForm" }, [
                    _vm.userProfile.profileComplete &&
                    !_vm.userProfile.phoneVerified
                      ? _c(
                          "div",
                          { attrs: { id: "step1" } },
                          [
                            _c(
                              "div",
                              { staticClass: "formTitle" },
                              [
                                _c("svg-image", {
                                  attrs: { image: "iconPhone" }
                                }),
                                _c("h5", [
                                  _vm._v(_vm._s(_vm.$t("validate.phone.head")))
                                ])
                              ],
                              1
                            ),
                            _c(
                              "b-form",
                              { on: { submit: _vm.onPhone } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "phone-group",
                                      "label-for": "phone",
                                      label: "",
                                      description: _vm.$t("validate.phone.desc")
                                    }
                                  },
                                  [
                                    !_vm.otpSent
                                      ? _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "validate.phone.label"
                                              ),
                                              id: "phone-group",
                                              "label-for": "phone"
                                            }
                                          },
                                          [
                                            _c("VuePhoneNumberInput", {
                                              staticClass: "form-group",
                                              attrs: {
                                                "no-example": "",
                                                color: "#ea0c0c",
                                                "border-radius": 0,
                                                required: "",
                                                "default-country-code": "ID"
                                              },
                                              on: { update: _vm.phoneUpdated },
                                              model: {
                                                value: _vm.form_.phone,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form_,
                                                    "phone",
                                                    $$v
                                                  )
                                                },
                                                expression: "form_.phone"
                                              }
                                            }),
                                            _c(
                                              "b-input-group-append",
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      block: "",
                                                      variant:
                                                        "outline-primary",
                                                      disabled:
                                                        _vm.checkingPhone
                                                    },
                                                    on: { click: _vm.sendOTP }
                                                  },
                                                  [
                                                    _vm.checkingPhone
                                                      ? _c("b-spinner", {
                                                          attrs: { small: "" }
                                                        })
                                                      : _vm._e(),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "validate.phone.send"
                                                            )
                                                          )
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.otpSent
                                      ? _c(
                                          "b-input-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "validate.otp.label"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "otpCode",
                                                type: "number",
                                                required: "",
                                                placeholder: _vm.$t(
                                                  "validate.otp.place"
                                                ),
                                                state: _vm.phoneState.state,
                                                disabled:
                                                  _vm.checkingPhone ||
                                                  _vm.phoneChecked
                                              },
                                              model: {
                                                value: _vm.formPhone.otpCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formPhone,
                                                    "otpCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "formPhone.otpCode"
                                              }
                                            }),
                                            _c(
                                              "b-input-group-append",
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "primary",
                                                      disabled: !_vm.formPhone
                                                        .otpCode
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.validatePhoneOTP
                                                    }
                                                  },
                                                  [
                                                    _vm.checkingPhone
                                                      ? _c("b-spinner", {
                                                          attrs: { small: "" }
                                                        })
                                                      : _vm._e(),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "validate.otp.btnv"
                                                            )
                                                          )
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm.showLater
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "warning"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.validateLater
                                                        }
                                                      },
                                                      [
                                                        _vm.checkingPhone
                                                          ? _c("b-spinner", {
                                                              attrs: {
                                                                small: ""
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "validate.otp.later"
                                                                )
                                                              )
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-form-invalid-feedback",
                                      {
                                        attrs: { state: _vm.phoneState.state }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.phoneState.message) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "b-form-valid-feedback",
                                      {
                                        attrs: { state: _vm.phoneState.state }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.phoneState.message) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.userProfile.profileComplete && !_vm.fileUploaded
                      ? _c(
                          "div",
                          { attrs: { id: "step2" } },
                          [
                            _c(
                              "div",
                              { staticClass: "formTitle" },
                              [
                                _c("svg-image", { attrs: { image: "iconID" } }),
                                _c("h5", [
                                  _vm._v(_vm._s(_vm.$t("validate.id.head")))
                                ])
                              ],
                              1
                            ),
                            _vm.fileError
                              ? _c("div", [
                                  _c("hr"),
                                  _c(
                                    "div",
                                    { staticClass: "successAlert" },
                                    [
                                      _c("svg-image", {
                                        attrs: { image: "iconReject" }
                                      }),
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("validate.alert.reject")
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("hr")
                                ])
                              : _vm._e(),
                            _c(
                              "b-form",
                              { on: { submit: _vm.onFile } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "idType-group",
                                      label: _vm.$t("validate.id.labeltype"),
                                      "label-for": "idType"
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        id: "idType",
                                        options: _vm.idTypes,
                                        state:
                                          _vm.formStatus.mbsdIDNumberType.state,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.form.mbsdIDNumberType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "mbsdIDNumberType",
                                            $$v
                                          )
                                        },
                                        expression: "form.mbsdIDNumberType"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "idFile-group",
                                      label: _vm.$t("validate.id.labelfile"),
                                      "label-for": "idFile",
                                      description: _vm.$t(
                                        "validate.id.descfile"
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-file", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "validate.id.placefile"
                                        ),
                                        "drop-placeholder": _vm.$t(
                                          "validate.id.dropfile"
                                        ),
                                        accept: ".jpg, .png, .jpeg"
                                      },
                                      on: { change: _vm.handleFileUpload },
                                      model: {
                                        value: _vm.idFile,
                                        callback: function($$v) {
                                          _vm.idFile = $$v
                                        },
                                        expression: "idFile"
                                      }
                                    }),
                                    _c(
                                      "b-progress",
                                      {
                                        staticClass: "mt-2",
                                        attrs: { max: 200, height: "2.5rem" }
                                      },
                                      [
                                        _c(
                                          "b-progress-bar",
                                          { attrs: { value: _vm.progress } },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(_vm.progressAction)
                                            ),
                                            _c("strong", [
                                              _vm._v(_vm._s(_vm.progress / 2))
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c("div", [
                                      _c(
                                        "label",
                                        { staticClass: "fileLabel" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("validate.id.labelselect")
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.idFile
                                                  ? _vm.idFile.name
                                                  : ""
                                              )
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("alert", { attrs: { status: _vm.status } }),
                                _c(
                                  "div",
                                  { staticClass: "clearfix" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          block: "",
                                          type: "submit",
                                          variant: "primary",
                                          disabled:
                                            _vm.loading || !_vm.fileSelected
                                        }
                                      },
                                      [
                                        _vm.loading
                                          ? _c("b-spinner", {
                                              attrs: { small: "", type: "grow" }
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("validate.id.btn"))
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.fileUploaded && !_vm.userProfile.profileComplete
                      ? _c(
                          "div",
                          { attrs: { id: "step3" } },
                          [
                            _c(
                              "div",
                              { staticClass: "formTitle" },
                              [
                                _c("svg-image", {
                                  attrs: { image: "iconOne" }
                                }),
                                _c("h5", [
                                  _vm._v(_vm._s(_vm.$t("validate.data.head")))
                                ])
                              ],
                              1
                            ),
                            _c(
                              "b-form",
                              { on: { submit: _vm.onData } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "idNumber-group",
                                      label: _vm.$t("validate.data.idlabel"),
                                      "label-for": "idNumber",
                                      description: _vm.$t(
                                        "validate.data.iddesc"
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "idNumber",
                                        state:
                                          _vm.formStatus.mbsdIDNumber.state,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.form.mbsdIDNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "mbsdIDNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.mbsdIDNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "birthDate-group",
                                      label: _vm.$t("validate.data.doblabel"),
                                      "label-for": "birthDate",
                                      description: _vm.$t("validate.data.dobd")
                                    }
                                  },
                                  [
                                    _c("datetime", {
                                      attrs: {
                                        id: "birthDate",
                                        state:
                                          _vm.formStatus.mbsdBirthDate.state,
                                        "max-datetime": "20061115",
                                        "value-zone": "Asia/Jakarta",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.form.mbsdBirthDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "mbsdBirthDate",
                                            $$v
                                          )
                                        },
                                        expression: "form.mbsdBirthDate"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "birthPlace-group",
                                      label: _vm.$t("validate.data.poblabel"),
                                      "label-for": "birthPlace",
                                      description: _vm.$t("validate.data.pobd")
                                    }
                                  },
                                  [
                                    _c("gmap-autocomplete", {
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "birthPlace",
                                        state:
                                          _vm.formStatus.mbsdBirthPlace.state,
                                        value: _vm.form.mbsdBirthPlace,
                                        options: _vm.birthplaceOptions,
                                        required: ""
                                      },
                                      on: { place_changed: _vm.setBirthPlace }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "bloodType-group",
                                      label: _vm.$t("validate.data.blo"),
                                      "label-for": "bloodType"
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        id: "bloodType",
                                        options: _vm.bloodType,
                                        state:
                                          _vm.formStatus.mbsdBloodType.state,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.form.mbsdBloodType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "mbsdBloodType",
                                            $$v
                                          )
                                        },
                                        expression: "form.mbsdBloodType"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "nationality-group",
                                      label: _vm.$t("validate.data.nat"),
                                      "label-for": "nationality"
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        state:
                                          _vm.formStatus.mbsdNationality.state,
                                        options: _vm.countries,
                                        label: "name",
                                        reduce: function(country) {
                                          return country.code
                                        }
                                      },
                                      model: {
                                        value: _vm.form.mbsdNationality,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "mbsdNationality",
                                            $$v
                                          )
                                        },
                                        expression: "form.mbsdNationality"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "country-group",
                                      label: _vm.$t("validate.data.cou"),
                                      "label-for": "country"
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.countries,
                                        label: "name",
                                        state: _vm.formStatus.mbsdCountry.state,
                                        reduce: function(country) {
                                          return country.code
                                        }
                                      },
                                      on: { input: _vm.setCountryRestriction },
                                      model: {
                                        value: _vm.form.mbsdCountry,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "mbsdCountry", $$v)
                                        },
                                        expression: "form.mbsdCountry"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm.form.mbsdCountry &&
                                _vm.form.mbsdCountry == "ID"
                                  ? _c(
                                      "b-form-group",
                                      {
                                        staticClass: "addressForm",
                                        attrs: {
                                          id: "address-group",
                                          label: _vm.$t("validate.data.dom"),
                                          description: _vm.$t(
                                            "validate.data.domdesc"
                                          ),
                                          "label-for": "address"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "mt-2",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "validate.data.add"
                                            )
                                          },
                                          model: {
                                            value: _vm.form.mbsdAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "mbsdAddress",
                                                $$v
                                              )
                                            },
                                            expression: "form.mbsdAddress"
                                          }
                                        }),
                                        _c("v-select", {
                                          staticClass: "mt-2",
                                          attrs: {
                                            options: _vm.fetchedOptions,
                                            placeholder: _vm.$t(
                                              "validate.data.cit"
                                            ),
                                            label: "label"
                                          },
                                          on: {
                                            search: _vm.fetchOptions,
                                            input: _vm.citySelected
                                          }
                                        }),
                                        _c("b-form-input", {
                                          staticClass: "mt-2",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "validate.data.pro"
                                            ),
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.form.mbsdProvinces,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "mbsdProvinces",
                                                $$v
                                              )
                                            },
                                            expression: "form.mbsdProvinces"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.form.mbsdCountry &&
                                _vm.form.mbsdCountry != "ID"
                                  ? _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "address-group",
                                          label: _vm.$t("validate.data.dom"),
                                          "label-for": "address"
                                        }
                                      },
                                      [
                                        _c("gmap-autocomplete", {
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "address",
                                            value: _vm.form.mbsdAddress,
                                            options: _vm.addressOptions,
                                            state:
                                              _vm.formStatus.mbsdAddress.state,
                                            required: "",
                                            placeholder: ""
                                          },
                                          on: { place_changed: _vm.setAddress }
                                        }),
                                        _c("b-form-input", {
                                          staticClass: "mt-2",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "validate.data.cit"
                                            ),
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.form.mbsdCity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "mbsdCity",
                                                $$v
                                              )
                                            },
                                            expression: "form.mbsdCity"
                                          }
                                        }),
                                        _c("b-form-input", {
                                          staticClass: "mt-2",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "validate.data.pro"
                                            ),
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.form.mbsdProvinces,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "mbsdProvinces",
                                                $$v
                                              )
                                            },
                                            expression: "form.mbsdProvinces"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "education-group",
                                      label: _vm.$t("validate.data.edu"),
                                      "label-for": "education",
                                      description: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        model: {
                                          value: _vm.form.mmedEducation,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "mmedEducation",
                                              $$v
                                            )
                                          },
                                          expression: "form.mmedEducation"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Elementary" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.edu.e1")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Junior" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.edu.e2")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Senior" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.edu.e3")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Diploma" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.edu.e4")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Bachelor" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.edu.e5")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Master" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.edu.e6")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Doctorate" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.edu.e7")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "occupation-group",
                                      label: _vm.$t("validate.data.ocu"),
                                      "label-for": "occupation",
                                      description: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        model: {
                                          value: _vm.form.mmedOccupation,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "mmedOccupation",
                                              $$v
                                            )
                                          },
                                          expression: "form.mmedOccupation"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Business" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o1")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Civil" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o2")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Educational" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o3")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Entrepreneur" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o4")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Freelance" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o5")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Healthcare" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o6")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Industrial" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o7")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Law" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o8")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Private" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.ocu.o9")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Professional" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "validate.select.ocu.o10"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Student" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "validate.select.ocu.o11"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Unemployed" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "validate.select.ocu.o12"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "Others" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "validate.select.ocu.o13"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "income-group",
                                      label: _vm.$t("validate.data.inc"),
                                      "label-for": "income",
                                      description: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        model: {
                                          value: _vm.form.mmedIncome,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "mmedIncome",
                                              $$v
                                            )
                                          },
                                          expression: "form.mmedIncome"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "income1" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.inc.i1")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "income2" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.inc.i2")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "income3" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.inc.i3")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "income4" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.inc.i4")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "income5" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.inc.i5")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: "income6" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("validate.select.inc.i6")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      id: "acceptanceNEWS",
                                      name: "acceptanceNEWS",
                                      value: "accepted",
                                      "unchecked-value": "not_accepted"
                                    },
                                    on: { change: _vm.doNewsCheckbox },
                                    model: {
                                      value: _vm.checkBoxes.agreeNewsletter,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.checkBoxes,
                                          "agreeNewsletter",
                                          $$v
                                        )
                                      },
                                      expression: "checkBoxes.agreeNewsletter"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t("validate.data.accnews")
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      id: "acceptance",
                                      name: "acceptance",
                                      value: "accepted",
                                      "unchecked-value": "not_accepted"
                                    },
                                    model: {
                                      value: _vm.checkBoxes.validIdentity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.checkBoxes,
                                          "validIdentity",
                                          $$v
                                        )
                                      },
                                      expression: "checkBoxes.validIdentity"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("validate.data.accok")) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      id: "acceptanceTC",
                                      name: "acceptanceTC",
                                      value: "accepted",
                                      "unchecked-value": "not_accepted"
                                    },
                                    model: {
                                      value: _vm.checkBoxes.agreeOnTnC,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.checkBoxes,
                                          "agreeOnTnC",
                                          $$v
                                        )
                                      },
                                      expression: "checkBoxes.agreeOnTnC"
                                    }
                                  },
                                  [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("validate.data.acctnp")
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _c("alert", { attrs: { status: _vm.status } }),
                                _c(
                                  "div",
                                  { staticClass: "clearfix" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          block: "",
                                          type: "submit",
                                          variant: "primary",
                                          size: "lg",
                                          disabled:
                                            _vm.loading ||
                                            _vm.checkBoxes.validIdentity !==
                                              "accepted" ||
                                            _vm.checkBoxes.agreeOnTnC !==
                                              "accepted"
                                        }
                                      },
                                      [
                                        _vm.loading
                                          ? _c("b-spinner", {
                                              attrs: { small: "", type: "grow" }
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("validate.data.btn"))
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm.userProfile.profileComplete && _vm.userProfile.phoneVerified
                ? _c("b-col", { staticClass: "personalData" }, [
                    _c(
                      "div",
                      { staticStyle: { padding: "0 1rem" } },
                      [
                        _vm.userProfile.profileData
                          ? _c(
                              "div",
                              { staticClass: "userProfile" },
                              [
                                _vm.userProfile.profileData.mbsdFile
                                  ? _c("img", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src:
                                          "https://facepool.oss-ap-southeast-5.aliyuncs.com/" +
                                          _vm.userProfile.profileData.mbsdFile
                                      },
                                      on: { error: _vm.photoProfileError }
                                    })
                                  : _vm._e(),
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.userProfile.profileData.mbsdFullName
                                    )
                                  )
                                ]),
                                _c("div", { staticClass: "profileStatus" }, [
                                  _vm.isVerified
                                    ? _c(
                                        "div",
                                        { staticClass: "profileVerified" },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: "person-fill",
                                                  variant: "light"
                                                }
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.status.verified"
                                                  )
                                                )
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isVerifying
                                    ? _c(
                                        "div",
                                        { staticClass: "profilePending" },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: "clock-fill",
                                                  variant: "light"
                                                }
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.status.verifying"
                                                  )
                                                )
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isFailed && !_vm.isVerifying == true
                                    ? _c(
                                        "div",
                                        { staticClass: "profileFailed" },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: "alert-triangle-fill",
                                                  variant: "light"
                                                }
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.status.failed"
                                                  )
                                                )
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isFailed && !_vm.isVerifying == true
                                    ? _c(
                                        "div",
                                        { staticClass: "profilePending" },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: "clock-fill",
                                                  variant: "light"
                                                }
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.status.pending"
                                                  )
                                                )
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm.isFailed ||
                                _vm.isVerifying == true ||
                                !_vm.isVerified
                                  ? _c(
                                      "b-alert",
                                      {
                                        attrs: { show: "", variant: "warning" }
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t("profile.pendingmsg")
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isVerified
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          pill: "",
                                          variant: "outline-secondary",
                                          size: "sm"
                                        },
                                        on: { click: _vm.updateProfile }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "pen" }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("profile.updatebtn"))
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.resetPasswordSent
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          pill: "",
                                          variant: "outline-secondary",
                                          size: "sm"
                                        },
                                        on: { click: _vm.resetPassword }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "arrow-counterclockwise"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("profile.resetbtn"))
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.resetPasswordSent
                                  ? _c(
                                      "b-alert",
                                      {
                                        attrs: { show: "", variant: "warning" }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "alert-circle" }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("profile.resetmsg"))
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("alert", { attrs: { status: _vm.status } }),
                        _vm.userProfile.profileData
                          ? _c(
                              "b-card-group",
                              { attrs: { deck: "" } },
                              [
                                _c(
                                  "b-card",
                                  {
                                    attrs: {
                                      header: _vm.$t(
                                        "profile.card.details.head"
                                      )
                                    }
                                  },
                                  [
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.card.details.nat")
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.userProfile.profileData
                                              .mbsdNationality
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.card.details.gen")
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm._f("gender")(
                                              _vm.userProfile.profileData
                                                .mbsdGender
                                            )
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.card.details.blo")
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm._f("bloodType")(
                                              _vm.userProfile.profileData
                                                .mbsdBloodType
                                            )
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.card.details.dob")
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm._f("moment")(
                                              _vm.userProfile.profileData
                                                .mbsdBirthDate,
                                              "D MMMM YYYY"
                                            )
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.card.details.pob")
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.userProfile.profileData
                                              .mbsdBirthPlace
                                          )
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "b-card",
                                  {
                                    attrs: {
                                      header: _vm.$t("profile.card.id.head")
                                    }
                                  },
                                  [
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("profile.card.id.typ"))
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm._f("cardType")(
                                              _vm.userProfile.profileData
                                                .mbsdIDNumberType
                                            )
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("profile.card.id.num"))
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.userProfile.profileData
                                              .mbsdIDNumber
                                          )
                                      )
                                    ]),
                                    _vm.userProfile.otherInfo
                                      ? _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("profile.card.id.edu")
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            ": " +
                                              _vm._s(
                                                _vm.userProfile.otherInfo
                                                  .mmedEducation
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm.userProfile.otherInfo
                                      ? _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("profile.card.id.ocu")
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            ": " +
                                              _vm._s(
                                                _vm.userProfile.otherInfo
                                                  .mmedOccupation
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "b-card",
                                  {
                                    attrs: {
                                      header: _vm.$t("profile.card.com.head")
                                    }
                                  },
                                  [
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("profile.card.com.ema"))
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.userProfile.profileData
                                              .mbsdEmail
                                          )
                                      )
                                    ]),
                                    _vm.userProfile.phoneData &&
                                    _vm.userProfile.phoneData.mbspCountryCode &&
                                    _vm.userProfile.phoneData.mbspNumber
                                      ? _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("profile.card.com.pho")
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            ": +" +
                                              _vm._s(
                                                _vm.userProfile.phoneData
                                                  .mbspCountryCode
                                              ) +
                                              _vm._s(
                                                _vm.userProfile.phoneData
                                                  .mbspNumber
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("profile.card.com.add"))
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.userProfile.profileData
                                              .mbsdAddress
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("profile.card.com.cit"))
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.userProfile.profileData.mbsdCity
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("profile.card.com.pro"))
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.userProfile.profileData
                                              .mbsdProvinces
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("profile.card.com.cou"))
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.userProfile.profileData
                                              .mbsdCountry
                                          )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "text-center mb-3" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  to: "/",
                                  pill: "",
                                  variant: "outline-secondary"
                                }
                              },
                              [
                                _c("b-icon", { attrs: { icon: "arrow-left" } }),
                                _vm._v(" " + _vm._s(_vm.$t("profile.dash")))
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/ProfileView.vue?vue&type=template&id=59f8aca4&
// module id = 861
// module chunks = 7